<div nz-col nzMd="24" nzXs="24">
    <nz-table #basicTable (nzQueryParams)="onQueryParamsChange($event)" nzSize="small" [(nzData)]="medicamentos" [nzFrontPagination]="false" [nzLoading]="loading" [nzTotal]="total" [nzPageSize]="pageSize" [nzPageIndex]="pageIndex">
        <thead>
            <tr>
                <th>ID</th>
                <th>Operação</th>
                <th>Cod. Barras</th>
                <th>Descrição</th>
                <th style="text-align:center;">Autorizador</th>
                <th>Ações</th>
            </tr>
        </thead>
        <tbody>
            <ng-template ngFor let-data [(ngForOf)]="basicTable.data">
                <tr>
                    <td>
                        {{ data.idmedicamento }}
                    </td>
                    <td>
                        <nz-tag nzColor="error" *ngIf="data.operacao === 'EXCLUSAO'">Removido</nz-tag>
                        <nz-tag nzColor="success" *ngIf="data.operacao === 'INCLUSAO'">Incluido</nz-tag>
                        <nz-tag nzColor="processing" *ngIf="data.operacao === 'ALTERADO'">Alterado</nz-tag>
                    </td>
                    <td>
                        {{ data?.medicamento?.ean }}
                    </td>
                    <td>
                        {{ data?.medicamento?.descricao }}
                    </td>
                    <td style="text-align:center;">
                        {{data?.medicamento?.programa?.autorizador?.nome}} <br>
                        {{ data?.medicamento?.programa?.nome}}    
                    </td>
                    <td>
                        <button
                        nz-popconfirm
                        nzPopconfirmTitle="Deseja realmente remover o item da prévia?"
                        nzOkText="Sim"
                        nzCancelText="Não"
                        (nzOnConfirm)="excluir(data?.idlog_medicamento_alterado)"
                        nz-button nzSize="small" nzDanger nzType="primary"><span nz-icon nzType="delete" nzTheme="outline"></span> Excluir</button>
                    </td>
                </tr>
            </ng-template>
        </tbody>
    </nz-table>
</div>